// extracted by mini-css-extract-plugin
export var active = "_1p-7";
export var backButton = "_1p-6";
export var clone = "_1p-c";
export var collapseBar = "_1p-g";
export var collapseMode = "_1p-i";
export var dragHandle = "_1p-a";
export var dropdownIcon = "_1p-e";
export var hidden = "_1p-o";
export var iconContainer = "_1p-l";
export var iconSwapper = "_1p-n";
export var navItem = "_1p-4";
export var navItemIcon = "_1p-d";
export var navProfile = "_1p-5";
export var notificationDot = "_1p-m";
export var optionsContainer = "_1p-f";
export var primaryNav = "_1p-0";
export var primaryTab = "_1p-j";
export var secondaryNav = "_1p-1";
export var selected = "_1p-k";
export var settingsNav = "_1p-2";
export var settingsNavItems = "_1p-3";
export var show = "_1p-b";
export var sideNav = "_1p-h";
export var teamItem = "_1p-8";
export var userProfileItem = "_1p-9";